"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isErrored = isErrored;
exports.isFailed = isFailed;
exports.isIdle = isIdle;
exports.isReceived = isReceived;
exports.isRequested = isRequested;
const types_1 = require("../status/types.js");
function isStatus(actual, expected) {
    return actual === expected;
}
function getStatusFromHybrid(hybrid) {
    var _a;
    return (_a = hybrid === null || hybrid === void 0 ? void 0 : hybrid.actionStatus) !== null && _a !== void 0 ? _a : hybrid;
}
function isErrored(status) {
    return isStatus(getStatusFromHybrid(status), types_1.AsyncStateStatus.Errored);
}
function isFailed(status) {
    return isStatus(getStatusFromHybrid(status), types_1.AsyncStateStatus.Failed);
}
function isIdle(status) {
    return isStatus(getStatusFromHybrid(status), types_1.AsyncStateStatus.Idle);
}
function isReceived(status) {
    return isStatus(getStatusFromHybrid(status), types_1.AsyncStateStatus.Received);
}
function isRequested(status) {
    return isStatus(getStatusFromHybrid(status), types_1.AsyncStateStatus.Requested);
}
//# sourceMappingURL=lib.js.map